<template>
  <div class="course-list">
    <div class="version-select">
      <!-- 选择学科 -->
      <ul class="subject-ul">
        <li
          @click="subjectClick(subject)"
          :class="{
            'is-active': subject.dl_subject_id === conditionList.dLSubjectId,
          }"
          v-for="subject in subjectList"
          :key="subject.dl_subject_id"
        >
          <span>{{ subject.code_name }}</span>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
      <!-- 选择版本 -->
      <ul class="text-book-ul">
        <li
          v-for="item in versionsList"
          @click="versionClick(item)"
          :class="{
            'is-active': item.dl_versions_id === conditionList.bookVersionId,
          }"
          :key="item.dl_versions_id"
        >
          <span>{{ item.versions_name }}</span>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
      <!-- 选择年级 -->
      <ul class="grade-ul">
        <li
          @click="gradeClick(grade)"
          :class="{ 'is-active': grade.grade_id === conditionList.gradeId }"
          v-for="grade in gradeList"
          :key="grade.dl_grade_id"
        >
          <span>{{ grade.grade_name }}</span>
          <i
            class="el-icon-check"
            v-show="grade.grade_id === conditionList.gradeId"
          ></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getClassAccurateCategory } from '@/api/pt';

export default {
  name: 'ChoiseEvaCategory',
  props: {
    classId: {},
    type: {},
    exerciseType: {},
  },
  data() {
    const { fromType, subjectId } = this.$route.query;
    return {
      conditionList: {
        crmSubjectId: '',
        dLSubjectId: '',
        bookVersionId: '',
        gradeId: '', //
        crmGradeId: '',
        testId: '',
        courseCode: '',
        sectionsId: '',
      },
      conditionNameList: {
        subjectName: '',
        versionsName: '',
        gradeName: '',
        testName: '',
      },
      subjectList: [],
      versionsList: [],
      gradeList: [],
      classList: [],
      testList: [],

      fromType,
      subjectId,
      textBookList: [],
      currentSubject: {},
      currentGrade: {},
      currentTextBook: {},
    };
  },
  methods: {
    subjectClick(subject) { // 切换学科
      this.knowledgeList = [];
      if (subject.crm_subject_id !== this.conditionList.crmSubjectId) {
        this.conditionList.crmSubjectId = subject.crm_subject_id;
        this.conditionList.dLSubjectId = subject.dl_subject_id;
        this.conditionList.bookVersionId = '';
        this.conditionNameList.versionsName = '';
        this.conditionList.gradeId = '';
        this.conditionList.crmGradeId = '';
        this.conditionNameList.gradeName = '';
        this.gradeList = [];
        this.testList = [];
        this.getAccurateCategory('versions');
      }
    },
    versionClick(value) { // 切换版本
      this.knowledgeList = [];
      if (value.dl_versions_id !== this.conditionList.bookVersionId) {
        this.conditionList.bookVersionId = value.dl_versions_id;
        this.conditionNameList.versionsName = value.versions_name;
        this.conditionList.gradeId = '';
        this.conditionList.crmGradeId = '';
        this.conditionNameList.gradeName = '';
        this.getAccurateCategory('grade');
      }
    },
    gradeClick(grade) { // 切换年级
      this.knowledgeList = [];
      this.conditionList.gradeId = grade.grade_id;
      this.conditionList.crmGradeId = grade.crm_grade_id;
      this.conditionNameList.gradeName = grade.grade_name;
      this.getAccurateCategory('test');
    },
    async getAccurateCategory(type, classId) {
      await getClassAccurateCategory({
        type,
        crm_subject_id: this.conditionList.crmSubjectId,
        dl_subject_id: this.conditionList.dLSubjectId,
        book_version_id: this.conditionList.bookVersionId,
        grade_id: this.conditionList.gradeId,
        class_id: this.classId || classId,
        crm_grade_id: this.conditionList.crmGradeId,
      }).then((res) => {
        // console.log(res);
        if (res.code === 200) {
          if (type === 'subjects') {
            this.subjectList = res.data;
            this.conditionList.crmSubjectId = this.subjectList[0].crm_subject_id;
            this.conditionList.dLSubjectId = this.subjectList[0].dl_subject_id;
            this.conditionNameList.subjectName = this.subjectList[0].code_name;
            this.getAccurateCategory('versions');
          }
          if (type === 'versions') {
            this.versionsList = res.data;
            this.conditionList.bookVersionId = this.versionsList[0].dl_versions_id;
            this.conditionNameList.versionsName = this.versionsList[0].versions_name;
            this.getAccurateCategory('grade');
          }
          if (type === 'grade') {
            this.gradeList = res.data;
            this.conditionList.gradeId = this.gradeList[0].grade_id;
            this.conditionList.crmGradeId = this.gradeList[0].crm_grade_id;
            this.conditionNameList.gradeName = this.gradeList[0].grade_name;
            this.testList = [];
            this.getAccurateCategory('test');
          }
          if (type === 'test') {
            this.testList = res.data;
            this.testList.forEach((item) => {
              this.$set(item, 'active', false);
              // this.$set(item, 'lesson_id', item.section_ids);
              this.$set(item, 'lesson_name', item.test_name);
            });
            this.conditionList.courseCode = this.testList[0].course_code;
            this.conditionList.testId = this.testList[0].test_id;
            this.conditionNameList.testName = this.testList[0].test_name;
            this.conditionList.sectionsId = this.testList[0].section_ids;
            this.$emit('change', this.testList);
            const cateGoryObj = {
              crmSubjectId: this.conditionList.crmSubjectId,
              dLSubjectId: this.conditionList.dLSubjectId,
              subjectId: this.conditionList.dLSubjectId,
              subjectName: this.conditionNameList.subjectName,
              gradeId: this.conditionList.gradeId,
              crmGradeId: this.conditionList.crmGradeId,
              gradeName: this.conditionNameList.gradeName,
              bookVersionId: this.conditionList.bookVersionId,
              versionsName: this.conditionNameList.versionsName,
            };
            if (this.type === 'EvaCommonWrong') {
              localStorage.setItem(`EvaCommonWrong-last_${this.classId}`, JSON.stringify(cateGoryObj));
              this.$store.commit('SET_EVA_WRONG_CATEGORY_OBJ', cateGoryObj);
            }
            if (this.type === 'EvaCommonWeak') {
              localStorage.setItem(`EvaCommonWeak-last_${this.classId}`, JSON.stringify(cateGoryObj));
              this.$store.commit('SET_EVA_WEAK_CATEGORY_OBJ', cateGoryObj);
            }
          }
        }
      });
    },
  },
  mounted() {
    if (!this.exerciseType) {
      this.getAccurateCategory('subjects', this.classId);
    }
  },
};
</script>
<style lang="scss">
.course-list {
  margin: 5px 0;
  font-size: 14px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 888;
  font-weight: 700;
  .is-active {
    color: #409eff;
  }
  .version-select {
    display: flex;
    justify-content: flex-start;
    // position: relative;
    ul {
      // margin-left: 20px;
      min-width: 180px;
      min-height: 160px;
      box-sizing: border-box;
      color: #606266;
      background: #fff;
      border-right: 1px solid #e4e7ed;
      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 10px;
        margin: 10px 0;
        cursor: pointer;
      }
    }
    .grade-ul {
      // border-right: none;
      li {
        justify-content: flex-start;
        span {
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
